/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, SVGIcon } from "@nordcloud/gnui";
import { Provider } from "~/generated/graphql";
import {
  FamilyHasIcon,
  ParseResourceType,
  SUBICONS,
  SubtypeHasIcon,
} from "~/components/Tables/Tools/ResourceTypeParser";
import { getProviderIconName } from "~/tools";

type Props = {
  provider: Provider;
  type?: string;
};

export function ProviderIcons({ provider, type }: Props) {
  const [family, subtype] = ParseResourceType(type ?? "");
  const hasSecondaryIcon = SubtypeHasIcon(subtype) || FamilyHasIcon(family);

  return (
    <FlexContainer
      justifyContent="center"
      direction="column"
      alignItems="center"
    >
      <SVGIcon
        name={getProviderIconName(provider)}
        size={hasSecondaryIcon ? "md" : "lg"}
      />
      {hasSecondaryIcon && (
        <SVGIcon
          // @ts-expect-error ParseResourceType needs to be properly typed */
          name={SubtypeHasIcon(subtype) ? SUBICONS[subtype] : family}
          size="md"
        />
      )}
    </FlexContainer>
  );
}
